import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { ejecutarSincronizacionMeta } from "./metaSync.server";
import { requireAdmin } from "./supabase.server";

const schema = z.object({ accessToken: z.string().min(20) });

export interface ResumenSincronizacion {
  configurado: boolean;
  leadsNuevos: number;
  filasMetricas: number;
  errores: string[];
}

/** Botón "Sincronizar ahora" de Campañas: lo mismo que el cron, sin esperar 6 h a las métricas. */
export const sincronizarMetaAhora = createServerFn({ method: "POST" })
  .validator((input: unknown) => schema.parse(input))
  .handler(async ({ data }): Promise<ResumenSincronizacion> => {
    await requireAdmin(data.accessToken);
    const resultado = await ejecutarSincronizacionMeta(process.env, { forzarMetricas: true });
    if (resultado.estado === "sin_configurar") {
      return {
        configurado: false,
        leadsNuevos: 0,
        filasMetricas: 0,
        errores: [`Falta configurar: ${resultado.faltan.join(", ")}`],
      };
    }
    return {
      configurado: true,
      leadsNuevos: resultado.leadsNuevos,
      filasMetricas: resultado.filasMetricas,
      errores: resultado.errores,
    };
  });
